import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { ResetLink } from '../../Header.styles';

const AccountWrapper = styled('ul')(
    (props) => css`
        list-style: none;
        padding: ${props.theme.spacing['16px']} 0;
        margin: 0;
        background: ${props.theme.colors.white};
        border-radius: ${props.theme.borderRadius['4px']};
        box-shadow: 0px 0px 8px rgba(50, 39, 68, 0.04),
            0px 0px 1px rgba(50, 39, 68, 0.32),
            0px 8px 8px -8px rgba(50, 39, 68, 0.16);
        min-width: 15.5rem;
        overflow: hidden;

        // increase specificity here to cater for older stacks
        ${ResetLink} {
            padding: ${props.theme.spacing['8px']}
                ${props.theme.spacing['16px']};
            text-decoration: none;
            font-size: 14px;
            font-weight: ${props.theme.fontWeight['400']};
            color: ${props.theme.colors['primary-dark']};
            display: flex;
            align-items: center;

            &:visited {
                text-decoration: none;
                color: ${props.theme.colors['primary-dark']};
            }

            &:hover {
                background: ${props.theme.colors[
                    'graphic-background-accent-light'
                ]};
            }
            > * {
                pointer-events: none;
                font-size: ${props.theme.type.body};
            }
            svg {
                margin-right: ${props.theme.spacing['16px']};
            }
        }
    `
);

export { AccountWrapper };
